import React, { useState } from 'react';
// import { OpenAI } from 'openai';
import '../../index.css';
import SearchBox from '../General/SearchBox';
import axios from '../../axiosConfig'


// Synonym Generator component that is visible in the bottom left part of the Qury Tool page.
const SynonymGenerator = () => {
  const [query, setQuery] = useState(''); // To hold the search query in UI
  const [displayedSynonyms, setDisplayedSynonyms] = useState([]);
  const [textAreaContent, setTextAreaContent] = useState('');
  const [removingSynonym, setRemovingSynonym] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null); // Debouncing purpose of the API call
  const [copied, setCopied] = useState(false);
  const [toggle, setToggle] = useState(false);


  // const API_KEY = env.REACT_APP_OPENAI_API_KEY;
  // const openai = new OpenAI({ apiKey: API_KEY, dangerouslyAllowBrowser: true });

  // Method that connects to the OpenAI endpoint and handles Synonym generation.
  const fetchSynonyms = async (word) => {
    // Get the existing synonyms from the text-area(output area) to generate unique non repetative keywords
    const existingWords = textAreaContent.split('/').map(s => s.trim()).filter(Boolean);
    const uniqueExistingWords = [...new Set(existingWords)];

    let mode = toggle ? 'description' : 'keyword';

    try {
      const res = await axios.post('/synonyms', {
        word,
        existingWords: uniqueExistingWords,
        mode,
      });

      updateDisplayedSynonyms(res.data.synonyms || []);
    } catch (err) {
      console.error('Error fetching synonyms from backend:', err);
    }
  };


  // gets the synonyms, defines an average card dimention and decides how many keywords to show at a time in the dislay
  const updateDisplayedSynonyms = (synonymsList) => {
    const cardWidth = 100;
    const cardHeight = 30;
    const maxCardsPerRow = Math.floor(200 / cardWidth);
    const maxRows = Math.floor(100 / cardHeight);
    const maxCards = maxCardsPerRow * maxRows;
    setDisplayedSynonyms(synonymsList.slice(0, maxCards));  // Sets the selected numbers of keywords in to the displayable list
  };

  // On every keypress, it is supposed to fire an AIP call to the OpenAPI.
   const handleSearchChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
      if (value.trim() !== '') {
        fetchSynonyms(value);
        if (!toggle) setTextAreaContent(value);
      } else {
        setDisplayedSynonyms([]);
        setTextAreaContent('');
      }
    }, 1500);
    setTimeoutId(newTimeoutId);
  };

  // Method to handle how the keywords are added in the text-area once clicked on the card
  const handleCardClick = (word) => {
    setTextAreaContent((prev) => {
      if (prev.trim() === '') {
        return `${word}`.trim().replace('.', '');
      } else {
        return `${prev} / ${word}`.trim().replace('.', '');
      }
    });
    handleRemoveSynonym(word);
  };

  // Method to handle how the card is removed from the card-list if the cross button in the card is clicked
  const handleRemoveSynonym = (word) => {
    setRemovingSynonym(word);
    setTimeout(() => {
      setDisplayedSynonyms((prev) => prev.filter(synonym => synonym !== word));
      setRemovingSynonym(null);
    }, 300);
  };

  // Function to handle the refresh button click
  const handleRefresh = () => {
    if (query.trim() !== "") {
      fetchSynonyms(query);
    }
  };

  // Below the Text-area, there is a Copy button. This method deals with how the set of keywords in the text-area gets copied on clicking this button
  const handleCopyToClipboard = (content) => {
    navigator.clipboard.writeText(content).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 4000); // Timeout function to show '✔️' symbol for 4 seconds after copy button click to ensure the user the values are copied
    });
  };

  // Handles how the toggling of modes happen (inclusive/exclusive)
  const handleToggle = () => {
    setToggle(!toggle);
    // Reset the textarea content when switching modes
    if (!toggle) {
      setTextAreaContent(query);
    }
  };

  // Function to clear the contents from the text-area
  const handleClear = () => {
    setQuery('');
    setTextAreaContent('');
    setDisplayedSynonyms([]);
  };

  return (
    <div className="bg-white shadow-md p-3 mt-3 rounded-xl">
      <div className="flex items-center justify-center">
        {/* Toggle button (top-left) */}
        <button onClick={handleToggle} className="mr-4 mb-3 rounded-full shadow-xl shadow-gray-400 hover:ring-2 ">
          <svg
            fill="#000000"
            width="26px"
            height="26px"
            viewBox="0 0 24.00 24.00"
            id="switch-left"
            xmlns="http://www.w3.org/2000/svg"
            className="icon line-color rounded-full shadow-lg"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(0.9599999999999991,0.9599999999999991), scale(0.92)">
              <rect
                x="0"
                y="0"
                width="24.00"
                height="24.00"
                rx="12"
                fill={toggle ? "#ff4d4d" : "#2ecbff"}
                strokewidth="0"
              ></rect>
            </g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.048"></g>
            <g id="SVGRepo_iconCarrier">
              <circle
                id="secondary"
                cx={toggle ? '14.5' : '9.5'}
                cy="12"
                r="2.5"
                style={{
                  fill: 'none',
                  stroke: '#f0fdff',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeWidth: 1.224,
                }}
              />
              <rect
                id="primary"
                x="6"
                y="3"
                width="12"
                height="18"
                rx="6"
                transform="translate(24 0) rotate(90)"
                style={{
                  fill: 'none',
                  stroke: '#050000',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeWidth: 1.224,
                }}
              />
            </g>
          </svg>
        </button>

        {/* Component Header */}
        <h1 className="text-base font-bold mb-3">Synonym Generator</h1>

        {/* Clear button (top-right) */}
        <button
          onClick={handleClear}
          className="ml-4 p1 mb-3 shadow-gray-600 shadow-xl ring-2 ring-gray-100 text-white rounded-full hover:ring-2 hover:ring-blue-300"
        >
        <svg width="24px" height="24px" viewBox="0 0 32.00 32.00" version="1.1" fill="#000000" transform="rotate(270)matrix(1, 0, 0, 1, 0, 0)">
        <g id="SVGRepo_iconCarrier">
          <g id="Page-1" stroke-width="0.00032" fill="none" fill-rule="evenodd">
            <g id="Icon-Set-Filled" transform="translate(-570.000000, -1089.000000)" fill="#ff0000">
              <path d="M591.657,1109.24 C592.048,1109.63 592.048,1110.27 591.657,1110.66 C591.267,1111.05 590.633,1111.05 590.242,1110.66 L586.006,1106.42 L581.74,1110.69 C581.346,1111.08 580.708,1111.08 580.314,1110.69 C579.921,1110.29 579.921,1109.65 580.314,1109.26 L584.58,1104.99 L580.344,1100.76 C579.953,1100.37 579.953,1099.73 580.344,1099.34 C580.733,1098.95 581.367,1098.95 581.758,1099.34 L585.994,1103.58 L590.292,1099.28 C590.686,1098.89 591.323,1098.89 591.717,1099.28 C592.11,1099.68 592.11,1100.31 591.717,1100.71 L587.42,1105.01 L591.657,1109.24 L591.657,1109.24 Z M586,1089 C577.163,1089 570,1096.16 570,1105 C570,1113.84 577.163,1121 586,1121 C594.837,1121 602,1113.84 602,1105 C602,1096.16 594.837,1089 586,1089 L586,1089 Z" id="cross-circle"></path>
            </g>
          </g>
        </g>
      </svg>
      </button>
      </div>

      {/* Search area */}
        <SearchBox 
            searchQuery={query} 
            handleSearch={handleSearchChange}
            mode={2}
            toggle={toggle}
            setQuery={setQuery}
            />
        {/* Refresh/Regenerate button (right to the SearchBox) */}
        <button
          className="mt-2 px-1 py-1 w-full justify-items-center bg-blue-400 text-white rounded-lg hover:bg-blue-500 shadow-gray-500 shadow-md hover:ring-1"
          onClick={handleRefresh}
        >
          <svg width="23px" height="23px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.83334 13.6C8.25804 14.4031 8.97945 15.0676 9.88888 15.4934C10.7983 15.9191 11.8465 16.083 12.8755 15.9604C13.9045 15.8378 14.8586 15.4353 15.594 14.8136L17 13.7451M17 16V13.6H14.5M16.1667 10.4C15.742 9.59687 15.0206 8.93238 14.1111 8.50664C13.2017 8.08091 12.1535 7.91699 11.1245 8.03959C10.0955 8.16219 9.1414 8.56467 8.40599 9.18637L7 10.2549M7 8V10.4H9.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>


      {/* Area to render the Synonym cards, that iterate through the Synonyms and renders one card for each keyword */}
      <div className="synonym-cards p-0.5">
        {displayedSynonyms.map((synonym, index) => (
          <div
            key={index}
            className={`synonym-card shadow-gray-400 shadow-md ring-gray-300 ring-1 inline-block bg-gray-200 rounded-xl p-1 text-sm font-semibold text-gray-700 mr-1 mb-1 transition-transform duration-150 ease-in-out ${removingSynonym === synonym ? 'animate-fade-out' : 'hover:scale-101 hover:ring-2 hover:ring-gray-500'}`}
          >
            <span onClick={() => handleCardClick(synonym)} className="cursor-pointer font-bold">
              {synonym}
            </span>
            {/* Cross Button Reject the Synonym */}
            <button
              className="ml-2 hover:ring-2 rounded-full"
              onClick={() => handleRemoveSynonym(synonym)}
            >
              <svg width="14px" height="14px" viewBox="0 0 32.00 32.00" version="1.1" fill="#000000" transform="rotate(270)matrix(1, 0, 0, 1, 0, 0)">
                <g id="SVGRepo_iconCarrier">
                  <g id="Page-1" stroke-width="0.00032" fill="none" fill-rule="evenodd">
                    <g id="Icon-Set-Filled" transform="translate(-570.000000, -1089.000000)" fill="#ff0000">
                      <path d="M591.657,1109.24 C592.048,1109.63 592.048,1110.27 591.657,1110.66 C591.267,1111.05 590.633,1111.05 590.242,1110.66 L586.006,1106.42 L581.74,1110.69 C581.346,1111.08 580.708,1111.08 580.314,1110.69 C579.921,1110.29 579.921,1109.65 580.314,1109.26 L584.58,1104.99 L580.344,1100.76 C579.953,1100.37 579.953,1099.73 580.344,1099.34 C580.733,1098.95 581.367,1098.95 581.758,1099.34 L585.994,1103.58 L590.292,1099.28 C590.686,1098.89 591.323,1098.89 591.717,1099.28 C592.11,1099.68 592.11,1100.31 591.717,1100.71 L587.42,1105.01 L591.657,1109.24 L591.657,1109.24 Z M586,1089 C577.163,1089 570,1096.16 570,1105 C570,1113.84 577.163,1121 586,1121 C594.837,1121 602,1113.84 602,1105 C602,1096.16 594.837,1089 586,1089 L586,1089 Z" id="cross-circle"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </div>
        ))}
      </div>

      {/* Text Area where all the selected Synonyms are added/displayed */}
      <textarea
        className="w-full p-1 mt-2 border h-full border-gray-400 rounded"
        value={textAreaContent}
        onChange={(e) => setTextAreaContent(e.target.value)}
        placeholder="Your text here..."
        rows="7"
        cols="20"
        style={{ resize: 'none' }}
      />

      <div className="flex bg-white rounded-md p-0.5">
        {/* Copy button (bottom) */}
        <button
          disabled={copied}
          onClick={() => handleCopyToClipboard(textAreaContent)}
          className="p-1 w-full bg-transparent disabled:bg-gray-200 disabled:border-gray-500 hover:bg-blue-600 text-blue-700 font-semibold hover:text-blue-100 border border-blue-500 hover:border-transparent rounded"
        >
          {copied ? '✔️' : 'Copy'} {/* Cnditionally renders the text to be shown inside the button */}
        </button>
      </div>
    </div>
  );
};

export default SynonymGenerator;
